<div *ngIf="showGlobalSpinner">
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</div>
<div breadcrumbs [option]='breadcrumbOptions'></div>

<div class="heading">
  <h2 class="h2-venue">Venue List</h2>
</div>

<div class="panel">
  <div class="container mt-4">
    <div class="row">
      <div class="col-md-12">
        <div class="list-group">
          <a *ngFor="let venue of venues" [routerLink]="['/admin/settings/manageVenues', venue.venueId]"
            class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">{{ venue.venueName }}</h5>
            </div>
            <p class="mb-1 short-desc">{{ venue.shortDesc }}</p>
            <small>Location: {{ venue.location }}</small>
            <!-- <div>
              <span class="loc-img"><img src="assets/icons/location-table.svg" alt=""></span>
               <span class="loc-venue">{{venue.location}}</span>
            </div> -->
          </a>
        </div>
        <div *ngIf="errorMessage" class="alert alert-danger mt-3">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>


</div>


<ng-template #displayErrorMessage>
  <p class="background-white m-t-xs">
    <span class="m-l-lg">
      <error-message [errorMessage]="errorMessage"></error-message>
    </span>
  </p>
</ng-template>

<ng-template #loading>
  <div class="loading" *ngIf="!showLoading">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>